<template>
    <!-- v-if="showButton || permFlag" -->
    <el-button type="primary" :size="size"  :style="buttonStyle" @click="handlerClick">{{
        buttonText }}</el-button>
</template>
  
<script>
import { debounce } from "@/assets/utils/unit";
export default {
    name: 'DynamicButton',
    props: {
        //按钮显示的文字
        buttonText: {
            type: String,
            required: true
        },
        //按钮权限标识符
        perm: {
            type: String,
            required: true
        },
        //按钮的样式
        buttonStyle: {
            type: String,
            default: ''
        },
        //按钮大小
        size: {
            type: String,
            default: ''
        },
        //如果没有权限按钮是否显示,默认不显示
        permFlag: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {

        };
    },
    //按钮的点击事件
    methods: {
        debounceClick:debounce(function() {
            this.$emit('click')
        },800),
        handlerClick() {
            // if (this.permFlag) {
            //     this.$message({
            //         message: '暂无权限访问',
            //         type: 'warning'
            //     });
            // } else {
            //     this.$emit(this.onClick)
            // }
            // this.$emit(this.onClick)
           this.debounceClick()
        }
    },
    computed: {
        // showButton() {
        //     return this.$store.state.perms.includes(this.perm);
        // },
    }
};
</script>
  